// import moment from 'moment'
import _ from 'lodash'
// ------------------------------------
// Commons
// ------------------------------------
export const MODAL_UNMOUNT = 'MODAL_UNMOUNT'
export const MODAL_HIDE = 'MODAL_HIDE'
export const MODAL_NETWORK_OFF = 'MODAL_NETWORK_OFF'
export const MODAL_SERVER_DOWN = 'MODAL_SERVER_DOWN'
export const MODAL_BOARDING_ERROR_HIBOUTIK = 'MODAL_BOARDING_ERROR_HIBOUTIK'
// ------------------------------------
// ADMIN
// ------------------------------------
export const MODAL_ADMIN_WARNING_IN_USE = 'MODAL_ADMIN_WARNING_IN_USE'

export const MODAL_ADMIN_CREATE_TABLE = 'MODAL_ADMIN_CREATE_TABLE'
export const MODAL_ADMIN_EDIT_TABLE = 'MODAL_ADMIN_EDIT_TABLE'
export const MODAL_ADMIN_DELETE_TABLE = 'MODAL_ADMIN_DELETE_TABLE'

export const MODAL_ADMIN_CREATE_PRICING = 'MODAL_ADMIN_CREATE_PRICING'
export const MODAL_ADMIN_EDIT_PRICING = 'MODAL_ADMIN_EDIT_PRICING'
export const MODAL_ADMIN_DELETE_PRICING = 'MODAL_ADMIN_DELETE_PRICING'

export const MODAL_ADMIN_CREATE_PLAYER = 'MODAL_ADMIN_CREATE_PLAYER'
export const MODAL_ADMIN_EDIT_PLAYER = 'MODAL_ADMIN_EDIT_PLAYER'
export const MODAL_ADMIN_DELETE_PLAYER = 'MODAL_ADMIN_DELETE_PLAYER'
export const MODAL_ADMIN_REORDER_PLAYER = 'MODAL_ADMIN_REORDER_PLAYER'

export const MODAL_ADMIN_CREATE_CATEGORY = 'MODAL_ADMIN_CREATE_CATEGORY'
export const MODAL_ADMIN_EDIT_CATEGORY = 'MODAL_ADMIN_EDIT_CATEGORY'
export const MODAL_ADMIN_DELETE_CATEGORY = 'MODAL_ADMIN_DELETE_CATEGORY'
export const MODAL_ADMIN_REORDER_CATEGORY = 'MODAL_ADMIN_REORDER_CATEGORY'

export const MODAL_ADMIN_CREATE_PRODUCT = 'MODAL_ADMIN_CREATE_PRODUCT'
export const MODAL_ADMIN_EDIT_PRODUCT = 'MODAL_ADMIN_EDIT_PRODUCT'
export const MODAL_ADMIN_DELETE_PRODUCT = 'MODAL_ADMIN_DELETE_PRODUCT'
export const MODAL_ADMIN_REORDER_PRODUCT = 'MODAL_ADMIN_REORDER_PRODUCT'

export const MODAL_ADMIN_EDIT_TAXE = 'MODAL_ADMIN_EDIT_TAXE'
export const MODAL_ADMIN_EDIT_PAYMENT = 'MODAL_ADMIN_EDIT_PAYMENT'
export const MODAL_ADMIN_EDIT_USER = 'MODAL_ADMIN_EDIT_USER'

export const MODAL_ADMIN_CREATE_CUSTOMER = 'MODAL_ADMIN_CREATE_CUSTOMER'
export const MODAL_ADMIN_EDIT_CUSTOMER = 'MODAL_ADMIN_EDIT_CUSTOMER'

export const MODAL_ADMIN_EDIT_LOCKER = 'MODAL_ADMIN_EDIT_LOCKER'
export const MODAL_ADMIN_CREATE_LOCKER = 'MODAL_ADMIN_CREATE_LOCKER'
export const MODAL_ADMIN_DELETE_LOCKER = 'MODAL_ADMIN_DELETE_LOCKER'
export const MODAL_ADMIN_CHANGE_CODE = 'MODAL_ADMIN_CHANGE_CODE'
// ------------------------------------
// CLIENT
// ------------------------------------
export const MODAL_CLIENT_SELECT_USER = 'MODAL_CLIENT_SELECT_USER'
export const MODAL_CLIENT_START_DAY = 'MODAL_CLIENT_START_DAY'
export const MODAL_CLIENT_END_DAY = 'MODAL_CLIENT_END_DAY'
export const MODAL_CLIENT_OPEN_TRANSACTION = 'MODAL_CLIENT_OPEN_TRANSACTION'
export const MODAL_CLIENT_CREATE_CYCLE = 'MODAL_CLIENT_CREATE_CYCLE'
export const MODAL_CLIENT_EDIT_CYCLE = 'MODAL_CLIENT_EDIT_CYCLE'
export const MODAL_CLIENT_DELETE_CYCLE = 'MODAL_CLIENT_DELETE_CYCLE'
export const MODAL_CLIENT_CONSO_TRANSACTION = 'MODAL_CLIENT_CONSO_TRANSACTION'
export const MODAL_CLIENT_PAYMENT = 'MODAL_CLIENT_PAYMENT'
export const MODAL_CLIENT_PAYMENT_HISTORY = 'MODAL_CLIENT_PAYMENT_HISTORY'
export const MODAL_CLIENT_SELECT_TABLE = 'MODAL_CLIENT_SELECT_TABLE'
export const MODAL_CLIENT_CANCEL_TRANSACTION = 'MODAL_CLIENT_CANCEL_TRANSACTION'
export const MODAL_CLIENT_SELECTION_PRODUCTS = 'MODAL_CLIENT_SELECTION_PRODUCTS'
export const MODAL_CLIENT_SELECTION_TRANSFERT =
  'MODAL_CLIENT_SELECTION_TRANSFERT'
export const MODAL_CLIENT_PRICING_MODAL = 'MODAL_CLIENT_PRICING_MODAL'
export const MODAL_CLIENT_ADMIN_CODE = 'MODAL_CLIENT_ADMIN_CODE'
export const MODAL_CLIENT_BAR_MODAL = 'MODAL_CLIENT_BAR_MODAL'
// ------------------------------------
// Logic Actions
// ------------------------------------
export const showModal = (id, payload) => {
  return dispatch => {
    dispatch({
      type: id,
      payload: payload
    })
  }
}

export const hideModal = modalToHide => {
  return (dispatch, getState) => {
    const { modals } = getState()
    if (modalToHide && modalToHide !== modals.currentModal) {
      return
    }
    dispatch({
      type: MODAL_HIDE
    })
  }
}
export const unmountModal = () => {
  return dispatch => {
    dispatch({
      type: MODAL_UNMOUNT,
      payload: null
    })
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { currentModal: null, payload: null, open: false }
export default function modalReducer(state = initialState, action) {
  if (!_.includes(action.type, 'MODAL')) return state
  if (action.type === MODAL_HIDE) return { ...state, open: false }
  if (action.type === MODAL_UNMOUNT) {
    return {
      ...state,
      currentModal: null,
      payload: null,
      open: false
    }
  }
  return {
    ...state,
    currentModal: action.type,
    payload: action.payload,
    open: true
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/modals.js